const common = {
  // Header utility bar
  'common.header.brochure': 'Request Brochure',
  'common.header.news': 'News',
  'common.header.sitemap': 'Sitemap',

  // Header logo
  'common.header.logoJa': 'Japan Butler Academy',
  'common.header.logoEn': 'THE JAPAN BUTLER ACADEMY / TJBA',

  // Header CTA button
  'common.header.ctaBrochure': 'Request Brochure',

  // Mobile menu aria
  'common.header.menuAriaLabel': 'Menu',

  // Mobile fixed CTA bar
  'common.mobileCta.brand': 'TJBA',
  'common.mobileCta.brochure': 'Brochure',
  'common.mobileCta.apply': 'Apply Now',

  // Nav items
  'common.nav.home': 'Home',
  'common.nav.about': 'About the Academy',
  'common.nav.about.overview': 'Academy Overview',
  'common.nav.about.philosophy': 'Philosophy & Principles',
  'common.nav.about.association': 'About the All Japan Butler Association / Japan Butler Academy (Main Campus)',
  'common.nav.about.facilities': 'Facilities & Equipment',
  'common.nav.about.access': 'Access',
  'common.nav.courses': 'Courses',
  'common.nav.courses.list': 'Course List & Comparison',
  'common.nav.courses.essential': 'Essential Course',
  'common.nav.courses.advanced': 'Advanced Course',
  'common.nav.courses.master': 'Master Course',
  'common.nav.courses.schedule': 'Annual Schedule',
  'common.nav.curriculum': 'Curriculum',
  'common.nav.curriculum.overview': 'Curriculum Overview',
  'common.nav.curriculum.training': 'Practical Training',
  'common.nav.curriculum.materials': 'Course Materials',
  'common.nav.curriculum.skills': 'Skills Acquired',
  'common.nav.pricing': 'Tuition & Benefits',
  'common.nav.pricing.overview': 'Tuition Overview',
  'common.nav.pricing.details': 'Tuition by Course',
  'common.nav.pricing.benefits': 'Course Benefits',
  'common.nav.pricing.certificate': 'About the Certificate',
  'common.nav.admission': 'Admissions',
  'common.nav.admission.overview': 'Admissions Overview',
  'common.nav.admission.application': 'Eligibility & Application Process',
  'common.nav.admission.apply': 'Application Form',
  'common.nav.admission.consultation': 'Book a Consultation',
  'common.nav.admission.seminar': 'Trial Session',
  'common.nav.corporate': 'Corporate Training',
  'common.nav.corporate.overview': 'About Corporate Training',
  'common.nav.corporate.brochure': 'Request Corporate Brochure',
  'common.nav.contact': 'Contact',
  'common.nav.contact.form': 'Contact Form',
  'common.nav.contact.faq': 'FAQ',
  'common.nav.contact.brochure': 'Request Brochure',
  'common.nav.contact.blog': 'Instructor Blog',

  // Footer section headings
  'common.footer.org': 'Organisation',
  'common.footer.courses': 'Courses',
  'common.footer.support': 'Support',
  'common.footer.legal': 'Legal',

  // Footer org info
  'common.footer.orgName': 'The All Japan Butler Association / Japan Butler Academy (Main Campus)',
  'common.footer.postal': '135-0064',
  'common.footer.address': '2-7-4 Aomi, Koto-ku, Tokyo',
  'common.footer.tel': 'TEL:',
  'common.footer.telNum': '+81-3-6824-4086',
  'common.footer.mail': 'Email:',
  'common.footer.mailAddr': 'info@butler-academy.jp',

  // Footer course links
  'common.footer.courses.list': 'Course List',
  'common.footer.courses.essential': 'Essential Course',
  'common.footer.courses.advanced': 'Advanced Course',
  'common.footer.courses.master': 'Master Course',
  'common.footer.courses.schedule': 'Annual Schedule',
  'common.footer.courses.recruitment': 'Admissions Schedule',
  'common.footer.courses.curriculum': 'Curriculum',

  // Footer support links
  'common.footer.support.admission': 'Admissions',
  'common.footer.support.faq': 'FAQ',
  'common.footer.support.brochure': 'Request Brochure',
  'common.footer.support.consultation': 'Book a Consultation',
  'common.footer.support.contact': 'Contact Us',
  'common.footer.support.blog': 'Instructor Blog',
  'common.footer.support.seminar': 'Trial Session',
  'common.footer.support.related': 'Related Organizations',

  // Footer corporate links (equal-weight group, separate from individual support links)
  'common.footer.corporate': 'Corporate Training',
  'common.footer.corporate.dispatch': 'Corporate Training (On-site Dispatch)',
  'common.footer.corporate.industries': 'Industry-Specific Programs',
  'common.footer.corporate.brochure': 'Request Corporate Brochure',

  // Footer corporate industry-specific landing pages (full-site coverage)
  'common.footer.corporate.industry.hotel': 'Hotels & Ryokan',
  'common.footer.corporate.industry.residence': 'Luxury Residences',
  'common.footer.corporate.industry.finance': 'Finance & Private Banking',
  'common.footer.corporate.industry.retail': 'Department Stores & Luxury Retail',
  'common.footer.corporate.industry.luxurySales': 'Luxury Sales',
  'common.footer.corporate.industry.clinic': 'Medical & Aesthetic Clinics',
  'common.footer.corporate.industry.automotive': 'Automotive & Mobility',
  'common.footer.corporate.industry.chauffeur': 'Chauffeur & Transport',

  // Footer "About the Academy" column (full-site coverage)
  'common.footer.about.personal': 'For Individuals (Campus-Based Course)',
  'common.footer.guide.academy': 'What Is Japan Butler Academy',
  'common.footer.guide.school': 'What Is a Butler School',
  'common.footer.guide.trainingSchool': 'What Is a Butler Training School',
  'common.footer.guide.job': 'What Does a Butler Do',

  // Footer related organizations column: the butler network only (association/
  // service/brand). Non-butler founder ventures are demoted to small copyright-bar
  // links (see familyRomance/ishiiYuichi below) rather than shown as a peer column.
  'common.footer.relatedSites': 'Related Organizations',
  'common.footer.relatedSites.association': 'The Japan Butler Association',
  'common.footer.relatedSites.thebutler': 'THE BUTLER',
  'common.footer.relatedSites.butlerbell': 'Butler Bell',
  'common.footer.relatedSites.queensbutler': "Queen's Butler",
  'common.footer.relatedSites.viewAll': 'About Our Related Organizations',

  // De-emphasized copyright-bar links: the founder's non-butler ventures
  'common.footer.relatedSites.familyRomance': 'Family Romance',
  'common.footer.relatedSites.familyRomanceIntro': 'About Family Romance',
  'common.footer.relatedSites.ishiiYuichi': 'Yuichi Ishii Official Site',
  'common.footer.relatedSites.ishiiYuichiIntro': 'About Yuichi Ishii',

  // Footer legal links
  'common.footer.legal.privacy': 'Privacy Policy',
  'common.footer.legal.terms': 'Terms of Use',
  'common.footer.legal.commercial': 'Specified Commercial Transactions',

  // Footer copyright
  'common.footer.copyright': 'The All Japan Butler Association / Japan Butler Academy (Main Campus) — The Japan Butler Academy (TJBA). All Rights Reserved.',

  // og:site_name
  'common.siteName': 'Japan Butler Academy',

  // Scroll to top button
  'common.backToTop': 'Back to top',

  // Footer: 執事を知る(一般知識)
  'common.footer.knowledge.title': 'Understanding Butlers',
  'common.footer.knowledge.job': 'What Does a Butler Do?',
  'common.footer.knowledge.become': 'How to Become a Butler',
  'common.footer.knowledge.school': 'What Is a Butler School?',
  'common.footer.knowledge.trainingSchool': 'What Is a Butler Training School?',
  'common.footer.knowledge.overseas': 'Butler Schools Around the World',
  'common.footer.knowledge.history': 'History of Butler Schools',
};

export default common;
